import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './documents-overview-items.component.html';
var DocumentsOverviewItemsComponent = (function () {
    function DocumentsOverviewItemsComponent() {
        this.search = { productName: '' };
    }
    DocumentsOverviewItemsComponent.prototype.ngOnChanges = function () {
        var _this = this;
        var _loop_1 = function (item) {
            item.documentTypes = (item.documents || [])
                .map(function (documentItem) { return documentItem.documentType; })
                .filter(function (documentType, index, context) { return (context.indexOf(documentType) === index); })
                .map(function (x) {
                var items = item.documents
                    .filter(function (documentItem) { return documentItem.documentType === x; })
                    .sort(function (documentItem1, documentItem2) {
                    if (documentItem1.languageTitleEn > documentItem2.languageTitleEn) {
                        return 1;
                    }
                    if (documentItem1.languageTitleEn < documentItem2.languageTitleEn) {
                        return -1;
                    }
                    return 0;
                });
                var primaryLanguageCode = _this.primaryLanguage.languageCode.toLowerCase();
                var selectedItem = items.filter(function (documentItem) {
                    return (documentItem.languageCode || '').toLocaleLowerCase() === primaryLanguageCode;
                })[0] ||
                    items.filter(function (documentItem) {
                        return (documentItem.languageCode || '').toLocaleLowerCase() === "en-us";
                    })[0] ||
                    items[0];
                return {
                    items: items,
                    selectedItem: selectedItem,
                    title: selectedItem.documentTypeTranslation || '',
                    type: x,
                };
            });
        };
        for (var _i = 0, _a = this.documentItems || []; _i < _a.length; _i++) {
            var item = _a[_i];
            _loop_1(item);
        }
    };
    DocumentsOverviewItemsComponent.prototype.clearSearch = function () {
        this.search.productName = '';
    };
    DocumentsOverviewItemsComponent.prototype.showMessage = function () {
        return this.documentItems.length === 0 || this.search.productName === '';
    };
    DocumentsOverviewItemsComponent.prototype.getMessage = function (filteredResultCount) {
        var totalResults = this.documentItems.length;
        if (this.showMessage()) {
            return '';
        }
        return this.primaryLanguage.translation.searchResultsMessage
            .replace('{filtered}', String(filteredResultCount))
            .replace('{total}', String(totalResults));
    };
    DocumentsOverviewItemsComponent.prototype.getDocumentTypeTitle = function (documentType) {
        var documentTypeEn = documentType.type
            .replace(/\s/gi, '')
            .replace(/-/gi, '')
            .replace(/^.{1}/gi, documentType.type[0].toLowerCase());
        if (typeof this.primaryLanguage !== 'object' || this.primaryLanguage === null) {
            return '';
        }
        if (typeof this.primaryLanguage.translation !== 'object' || this.primaryLanguage.translation === null) {
            return '';
        }
        return this.primaryLanguage.translation[documentTypeEn];
    };
    DocumentsOverviewItemsComponent.prototype.getPlaceholderMessage = function () {
        if (typeof this.primaryLanguage !== 'object' || this.primaryLanguage === null) {
            return undefined;
        }
        var placeholderMessage = this.languageIsEnglish ? this.primaryLanguage.translation.searchFieldPlaceholder
            : this.primaryLanguage.translation.searchFieldPlaceholder + " (Search)";
        return placeholderMessage;
    };
    DocumentsOverviewItemsComponent.prototype.getSearchTranlsation = function (searchTranslation) {
        return typeof searchTranslation === 'string' && searchTranslation !== '' ? "(" + searchTranslation + ")" : undefined;
    };
    DocumentsOverviewItemsComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DocumentsOverviewItemsComponent.prototype, "documentItems", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DocumentsOverviewItemsComponent.prototype, "primaryLanguage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DocumentsOverviewItemsComponent.prototype, "languageIsEnglish", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DocumentsOverviewItemsComponent.prototype, "warningAndDeclarationsUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DocumentsOverviewItemsComponent.prototype, "itemsLoading", void 0);
    DocumentsOverviewItemsComponent = __decorate([
        Component({
            selector: 'documentsOverviewItems',
            template: template,
        })
    ], DocumentsOverviewItemsComponent);
    return DocumentsOverviewItemsComponent;
}());
export { DocumentsOverviewItemsComponent };
